import type { TipoBeneficioClube } from "../../../services/clubeBeneficios"
import type {
    BeneficioForm,
    ClubeBeneficiosModel,
    PlanoClubeForm,
} from "../models/clubeBeneficiosModel"

export enum ClubeBeneficiosActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR_PLANO = "ADICIONAR_PLANO",
    REMOVER_PLANO = "REMOVER_PLANO",
    RESTAURAR_PLANOS_EXCLUIDOS = "RESTAURAR_PLANOS_EXCLUIDOS",
    MOVER_PLANO = "MOVER_PLANO",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    ADICIONAR_BENEFICIO = "ADICIONAR_BENEFICIO",
    ATUALIZAR_BENEFICIO = "ATUALIZAR_BENEFICIO",
    REMOVER_BENEFICIO = "REMOVER_BENEFICIO",
}

export type CampoClubeEditavel = Extract<
    keyof PlanoClubeForm,
    "ativo" | "nome" | "descricao" | "valorMensal"
>
export type CampoBeneficioEditavel = Exclude<keyof BeneficioForm, "chave" | "id" | "tipo">

export type ClubeBeneficiosActionModel =
    | {
          type: ClubeBeneficiosActionsTypes.CARREGAR
          payload: ClubeBeneficiosModel
      }
    | { type: ClubeBeneficiosActionsTypes.ADICIONAR_PLANO }
    | {
          type: ClubeBeneficiosActionsTypes.REMOVER_PLANO
          payload: { chavePlano: string }
      }
    | { type: ClubeBeneficiosActionsTypes.RESTAURAR_PLANOS_EXCLUIDOS }
    | {
          type: ClubeBeneficiosActionsTypes.MOVER_PLANO
          /** -1 = sobe uma posição; 1 = desce uma posição */
          payload: { chavePlano: string; direcao: -1 | 1 }
      }
    | {
          type: ClubeBeneficiosActionsTypes.ATUALIZAR_CAMPO
          payload: { chavePlano: string; campo: CampoClubeEditavel; valor: string | boolean }
      }
    | {
          type: ClubeBeneficiosActionsTypes.ADICIONAR_BENEFICIO
          payload: { chavePlano: string; tipo?: TipoBeneficioClube }
      }
    | {
          type: ClubeBeneficiosActionsTypes.ATUALIZAR_BENEFICIO
          payload: {
              chavePlano: string
              chave: string
              campo: CampoBeneficioEditavel
              valor: string | boolean
          }
      }
    | {
          type: ClubeBeneficiosActionsTypes.REMOVER_BENEFICIO
          payload: { chavePlano: string; chave: string }
      }
